export class CONNDROPDATA {

  //MobPhoneID: number;
  ID: number;
  VQuad_Timestamp: Date;
  GPS_Position: string;
  GPS_Lat: number;
  GPS_Long: number;
  Net_Speed_Test: string;
  VQuad_CallID: string;
  VQuad_Location: string;
  VQuad_PhoneID: string;
  Target_Server: string;
  Start_GPS_Position: string;
  Start_GPS_Lat: number;
  Start_GPS_Long: number;
  Start_Timestamp: Date;
  TestStatus: string;
  Battery_Level: number;
  RSSI: number;
  Network_Type: string;
  TN_Number: string;
  Call_Timestamp: Date;
  CallType_Orig: string;
  CallType_Term: string;

    constructor() {
      //this.MobPhoneID= 0;
      this.ID= 0;
      this.VQuad_Timestamp= new Date();
      this.GPS_Position = "";
      this.GPS_Lat= 0;
      this.GPS_Long= 0;
      this.Net_Speed_Test = "";
      this.VQuad_CallID = "";
      this.VQuad_Location = "";
      this.VQuad_PhoneID = "";
      this.Target_Server = "";
      this.Start_GPS_Position = "";
      this.Start_GPS_Lat= 0;
      this.Start_GPS_Long= 0;
      this.Start_Timestamp= new Date();
      this.TestStatus = "";
      this.Battery_Level = 0;
      this.RSSI = 0;
      this.Network_Type = "";
      this.TN_Number = "";
      this.Call_Timestamp= new Date();
      this.CallType_Orig = "";
      this.CallType_Term = "";
        
        }
}
